import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueChangeValid } from '@/api/gucangSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'


const __default__ = { name: 'BecomeValid' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ applyReason: string; clueIdList: any[] }>({ applyReason: '', clueIdList: [] })
const formRules = reactive({
  applyReason: [{ required: true, message: '请填写申请原因' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleBecomeValidOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.clueIdList = selectedData.value.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueChangeValid(params)
      .then(() => {
        DcMessage.success('申请转有效成功')
        resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleBecomeValidCancel = () => {
  resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "申请转有效",
    "body-style": { padding: '30px' },
    "confirm-loading": loading.value,
    onOk: handleBecomeValidOk,
    onCancel: handleBecomeValidCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, { "wrapper-col": { span: 24 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, _mergeProps({ label: "申请原因" }, _unref(validateInfos).applyReason), {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                value: dataForm.applyReason,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.applyReason) = $event)),
                maxlength: 2000,
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})